import { smartLookIdentify } from "../services/SmartlookRecorder";
import { useContext, useEffect, useMemo, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import useAuthApi from "../api/useAuth.api";
import useUsersApi from "../api/users.api";
import Logo from "../assets/images/cordelia-new-logo3x.png";
import LogoShort from "../assets/images/logoshort.png";

import Arrow from "../assets/images/left-arrow.svg";
import Sidebar from "../components/Sidebar/Sidebar";
import Topbar from "../components/Topbar/Topbar";
import { PrivateProvider } from "../context/private.context";
import { SelectedUserProvider } from "../context/selecteduser.context";
import SnackbarContext from "../context/snackbar.context";

const HomeLayout = () => {
  const snackbarCtx = useContext(SnackbarContext);
  const authWholeData = useAuthApi({ snackbarCtx });
  const { authData, fetchUserProfile } = authWholeData;
  const [isNavOpen, setIsNavOpen] = useState(true);
  const getChangeUsers = useUsersApi();
  const getAccessToken = (): string => {
    return localStorage.getItem("accessToken") || "";
  };

  const data = useMemo(
    () => ({
      auth: authWholeData,
      getChangeUsers,
    }),
    [authData]
  );

  useEffect(() => {
    if (getAccessToken() && !authData?.id) {
      fetchUserProfile();
    }
  }, [authData]);

//   useEffect(() => {
//     if (
//       process.env.REACT_APP_ENV === "production" && authData && authData.id
//     ) {
//       smartLookIdentify(authData?.id, 
//         {
        
//           "userId": authData.id,
//           "name": authData.firstName + " " + authData.lastName,
//           "email": authData.email,
//           "role": authData.role
//         }
//       );
// }
//   }, [authData]);

return (
  <PrivateProvider data={data}>
      <SelectedUserProvider>
        <>
          <div className="min-w-[100vw] max-w-[100vw] bg-[#f7f7f7] h-[100vh]" style={{ overflow: "hidden" }}>
            <div className="d-flex h-full w-full ">
              <div className={`${isNavOpen ? "min-w-[240px]" : "min-w-[90 px]"} bg-white `}>
                <div className="d-flex justify-evenly my-4">
                  <a href="/">
                    {isNavOpen ? <img src={Logo} alt="" width={180} /> : <img src={LogoShort} alt="" width={40} />}
                  </a>
                  <img src={Arrow} alt="" width={30} onClick={() => setIsNavOpen(prev => !prev)}
                    style={{ transform: isNavOpen ? "rotate(180deg)" : "", cursor: "pointer" }}
                  />
                </div>
                <Sidebar hide={!isNavOpen} />
              </div>
              <div className={`${isNavOpen ? "w-[calc(100vw-240px)]" : "w-[calc(100vw-90px)]"}`}>
                <Topbar />
                <div className="pt-10 px-[40px] h-[calc(100vh-5rem)] overflow-auto" id="home-layout">
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </>
      </SelectedUserProvider>
  </PrivateProvider>
);
};
export default HomeLayout;
